import { Form } from 'antd';
import { useIntl } from 'react-intl';
import { DEFAULT_PAGINATION } from 'constants/common';
import { FilterForm } from 'components/form';
import {
  StyledSpace,
  StyledFormItem,
  StyledInputSearch,
} from 'styles/overrides';
import { normalizeSearchData, normalizeSubmitSearchData } from 'utils/common';
import {
  GenderSelector,
  ReceptionistSelector,
  TechnicianSelector,
  LocaleSelector,
  FromToDateSelector,
} from 'components/selectors';

export default function OrderFilterSearch({ onSubmit, initialValues }) {
  const intl = useIntl();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit(
      normalizeSubmitSearchData({
        ...initialValues,
        ...values,
        page: DEFAULT_PAGINATION.PAGE,
      }),
    );
  };

  const handleValuesChange = (changedValues) => {};

  return (
    <FilterForm
      onFinish={handleSubmit}
      initialValues={normalizeSearchData(initialValues)}
      formInstance={form}
      onValuesChange={handleValuesChange}
    >
      <StyledSpace size={16}>
        <StyledFormItem noStyle shouldUpdate>
          {(form) => (
            <StyledFormItem name="search">
              <StyledInputSearch
                style={{ width: 'auto' }}
                $customType="filter"
                placeholder={intl.formatMessage({
                  id: 'common.placeholder.search',
                })}
                onSearch={form.submit}
              />
            </StyledFormItem>
          )}
        </StyledFormItem>
        
        <StyledFormItem noStyle shouldUpdate>
          {(form) => (
            <StyledFormItem name="feedback_code">
              <StyledInputSearch
                style={{ width: 'auto' }}
                $customType="filter"
                placeholder={intl.formatMessage({
                  id: 'common.placeholder.feedback_code',
                })}
                onSearch={form.submit}
              />
            </StyledFormItem>
          )}
        </StyledFormItem>

        <StyledFormItem name="locale_code">
          <LocaleSelector
            placeholder={intl.formatMessage({
              id: 'common.placeholder.locales',
            })}
            $customType="filter"
            isFilter
            allowClear
          />
        </StyledFormItem>

        <StyledFormItem name="gender">
          <GenderSelector
            placeholder={intl.formatMessage({
              id: 'views.orders.table.gender',
            })}
            $customType="filter"
            allowClear
          />
        </StyledFormItem>

        <StyledFormItem name="receptionist_code">
          <ReceptionistSelector
            placeholder={intl.formatMessage({
              id: 'views.orders.form.label.receptionistCode',
            })}
            $customType="filter"
            allowClear
          />
        </StyledFormItem>

        <StyledFormItem name="technician_code">
          <TechnicianSelector
            placeholder={intl.formatMessage({
              id: 'views.orders.form.label.technicianCode',
            })}
            $customType="filter"
            allowClear
          />
        </StyledFormItem>

        <StyledFormItem name="fromToDate">
          <FromToDateSelector allowClear format="DD/MM/YYYY" />
        </StyledFormItem>
      </StyledSpace>
    </FilterForm>
  );
}
